"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
exports.default = (react_1.default.createElement("path", { d: "M12 15L11.4697 15.5303C11.7626 15.8232 12.2374 15.8232 12.5303 15.5303L12 15ZM5.46967 9.53033L11.4697 15.5303L12.5303 14.4697L6.53033 8.46967L5.46967 9.53033ZM12.5303 15.5303L18.5303 9.53033L17.4697 8.46967L11.4697 14.4697L12.5303 15.5303Z", fill: "currentColor" }));
